export default {"src":"/_next/static/media/secureShield.a0547760.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};